<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showEditBenefitGroup"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="editBenefit"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Edit Benefit Group</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="edit_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ edit_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="edit_success"
              class="p-1 text-center text-sm w-full bg-green-200"
            >
              {{ edit_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Benefit Group Name</label>
              <input
                v-model="info.Name"
                required
                type="text"
                class="p-2 bg-gray-200 rounded-full w-full"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Description</label>
              <textarea
                v-model="info.Description"
                required
                class="p-2 bg-gray-200 rounded-md w-full"
              ></textarea>
            </div>
            <div class="text-sm">
              <!-- {{ benefits }} -->
              <label class="block pb-1">Benefits</label>
              <div class="grid grid-cols-2 gap-4">
                <div
                  v-for="benefit in benefits"
                  :key="benefit.benefitId"
                  class="flex items-center"
                >
                  <input
                    type="checkbox"
                    :id="'benefit-' + benefit.benefitId"
                    @change="updateBenefitIds"
                    :value="benefit.benefitId"
                    :checked="isBenefitChecked(benefit.benefitId)"
                    class="mr-2 cursor-pointer"
                  />
                  <label
                    :for="'benefit-' + benefit.benefitId"
                    class="text-gray-700 cursor-pointer"
                    >{{ benefit.Name }}</label
                  >
                </div>
              </div>
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Save
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from 'axios';
import { mapGetters } from 'vuex';
import Loader from '@/components/loader/loader.vue';

export default {
  name: 'EditBenefit',
  props: ['showEditBenefitGroup', 'reload', 'info'],
  components: { Loader },
  data() {
    return {
      edit_error: null,
      edit_success: null,
      loading: false,
      benefits: [],
    };
  },

  computed: {
    ...mapGetters(['getOrganization', 'getToken']),
  },

  watch: {
    showEditBenefitGroup(newSate) {
      if (newSate) {
        this.getBenefits();
      }
    },
  },

  methods: {
    close() {
      this.$emit('close');
      this.reload();
    },

    updateBenefitIds(e) {
      console.log(e);
      let data = {
        BenefitGroupId: this.info.BenefitGroupId,
        BenefitId: e.target.value,
        BenefitLineId: this.info.Benefits?.find(
          (b) => b.BenefitId === e.target.value
        )?.LineId,
      };

      console.log(
        e.target.value,
        this.info.Benefits?.map((b) => b.BenefitId)
      );
      if (!e.target.checked) {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
          },
          data,
        };

        axios
          .delete(
            `${this.getOrganization}/setup/benefit/group/line/${this.$ApiVersion}/unassign`,
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.$notify.success({
                  title: 'Success',
                  message: response.data.StatusMessage,
                });
                this.reload();
              } else {
                this.$notify.error({
                  title: 'Failure',
                  message: response.data.StatusMessage,
                });
              }
            },
            (error) => {
              this.loading = false;
              this.$notify.error({ title: 'Failure', message: error.message });
            }
          );
      } else {
        this.loading = true;
        const options = {
          headers: {
            Authorization: `Bearer ${this.getToken}`,
            'Content-Type': 'application/json',
          },
        };

        axios
          .post(
            `${this.getOrganization}/setup/benefit/group/line/${this.$ApiVersion}/assign`,
            JSON.stringify(data),
            options
          )
          .then(
            (response) => {
              this.loading = false;
              if (response.data.StatusCode == 200) {
                this.$notify.success({
                  title: 'Success',
                  message: response.data.StatusMessage,
                });
                this.reload();
              } else {
                this.$notify.error({
                  title: 'Failure',
                  message: response.data.StatusMessage,
                });
              }
            },
            (error) => {
              this.loading = false;
              this.$notify.error({ title: 'Failure', message: error.message });
            }
          );
      }
    },

    isBenefitChecked(benefitId) {
      return this.info.Benefits?.some((b) => b.BenefitId === benefitId);
    },

    editBenefit() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          'Content-Type': 'application/json',
        },
      };

      axios
        .put(
          `${this.getOrganization}/setup/benefit/group/${this.$ApiVersion}/edit`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.edit_success = response.data.StatusMessage;
              setTimeout(() => {
                this.edit_success = null;
                this.reload();
              }, 2500);
            } else {
              this.edit_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.edit_error = error.message;
          }
        );
    },

    getBenefits() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/benefit/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.benefits = response.data.Data;
              console.log(this.benefits);
              console.log(this.info.Benefits);
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  transform: translate(-50%, -50%);
}
</style>
